import React, { useRef, useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import useFetch from 'use-http';
import Hero from '../../shared/Hero';
import Categories from './Categories';
import HeroError from '../../shared/HeroError';
import useCancelationToken from '../../hooks/useCancelationToken';
import Modal from '../../shared/Modal/Modal';
import Button from '../../shared/Button';
import { useCartDispatch, useCartState } from '../../context/CartContext';
import { useHistory } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { useSettingsState } from '../../context/SettingsContext';
import { exponeaCapture } from '../../hooks/exponeaCapture';
import { useUserDispatch, useUserState } from '../../context/UserContext';
import CategoriesNew from './Categories/new/CategoriesNew';
import BenefitsSection from './Benefits/BenefitsSection';
import { useParams } from 'react-router-dom';

const CategoriesPage = () => {
  const { loading, error, data = [] } = useFetch('/ServiceTypes', []);
  const cartState = useCartState();
  const { status } = useParams();
  const servicesRef = useRef();
  const userDispatch = useUserDispatch();
  const [serviceTitle, setServiceTitle] = useState();
  const [registrationDate, setRegistrationDate] = useState();
  const [cancelledRegistration, setCancelledRegistration] = useState(false);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const history = useHistory();
  const { phoneNumber } = useSettingsState();

  const [cancelLoading, setCancelLoading] = useState(false);

  const [showLinkExpiryModal, setShowLinkExpiryModal] = useState(
    history.location?.state?.isAccountTokenExpired,
  );
  const { post: cancelCoupon } = useFetch('/CouponManagement/CancelCoupon');

  const { post: cancelComplex } = useFetch(
    '/ComplexServiceRegistrationManagment/CancelComplex',
  );

  const {
    get: getRegistrationPaymentStatus,
    response: getRegistrationPaymentStatusResponse,
  } = useFetch('/RegistrationManagement/IsCancelled');

  const { post: cancelRegistrationRequestSend } = useFetch(
    `/RegistrationManagement/Registrations/Cancel`,
  );

  const [registrationCancelationToken, setRegistrationCancelationToken] =
    useState('');
  const [cantBePaidModalVisible, setCantBePaidModalVisible] = useState(false);
  const [cantBePaidModalText, setCantBePaidModalText] = useState(
    `Apmokėjimas negalimas. Prašome pakartoti registraciją ir susisiekti tel. nr: ${phoneNumber}`,
  );
  const [
    previewRegistrationCancelationModalVisible,
    setPreviewRegistrationCancelationModalVisible,
    cancelRegistration,
    previewRegistrationCancelationFailureModalVisible,
    setPreviewRegistrationCancelationFailureModalVisible,
    manuallyConfirmedRegistrationVisible,
    setManuallyConfirmedRegistrationVisible,
    registrationCancelled,
    setRegistrationCancelled,
  ] = useCancelationToken();
  const dispatch = useCartDispatch();

  useEffect(() => {
    if (showLinkExpiryModal) {
      history.replace({ state: {} });
    }
  }, [showLinkExpiryModal]);

  useEffect(() => {
    if (cartState.leftToPaysera) {
      setIsCancelModalVisible(true);
    }
  }, [cartState.leftToPaysera]);

  useEffect(() => {
    if (status === 'cancel') {
      setIsCancelModalVisible(true);
    }
  }, [status]);

  const clearPayseraReturnState = () => {
    dispatch({ type: 'REMOVE_LEFTTOPAYSERA' });
    userDispatch({
      type: 'SET_LEFT_CART_PAGE',
      left: false,
    });
  };

  const handleKeepRegistration = () => {
    setIsCancelModalVisible(false);
    clearPayseraReturnState();
    history.replace('/');
  };

  const handleConfirmCancellation = async () => {
    if (!cartState.registrationId) {
      handleKeepRegistration();
      return;
    }

    setCancelLoading(true);

    if (
      cartState.orderType !== 'coupon' &&
      cartState.orderType !== 'complex'
    ) {
      const exponea = JSON.parse(
        sessionStorage.getItem('exponeaTrack') || '[]',
      );
      exponea.push({ name: 'Registration status', value: 'Cancelled' });
      exponea.push({ name: 'booking_stage', value: 'Cancelled' });

      exponeaCapture(exponea, 'booking');
      sessionStorage.removeItem('exponeaTrack');
    }

    if (cartState.orderType === 'coupon') {
      await cancelCoupon(`?orderId=${cartState.registrationId}`);
    } else if (cartState.orderType === 'complex') {
      await cancelComplex(`?orderId=${cartState.registrationId}`);
    } else {
      await cancelRegistrationRequestSend('', {
        cancelationToken: cartState.registrationId,
      });
    }

    dispatch({ type: 'RESET_REGISTRATION_ID' });
    clearPayseraReturnState();
    setCancelLoading(false);
    setIsCancelModalVisible(false);
    setCancelledRegistration(true);
    history.replace('/');
  };

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        if (cartState.leftToPaysera) {
          history.go(1);
        }
      }
    };
  }, [history]);

  useEffect(() => {}, []);

  useEffect(() => {
    setPreviewRegistrationCancelationModalVisible(false);
    const cancelToken = new URLSearchParams(window.location.search).get(
      'cancel_token',
    );

    const serviceTitle = new URLSearchParams(window.location.search).get(
      'serviceTitle',
    );

    const registrationDate = new URLSearchParams(window.location.search).get(
      'registration_date',
    );

    const orderId = new URLSearchParams(window.location.search).get('order_id');

    if (cancelToken) {
      setServiceTitle(serviceTitle);
      setRegistrationCancelationToken(cancelToken);
      setRegistrationDate(registrationDate);
      (async function () {
        setPreviewRegistrationCancelationModalVisible(true);
      })();
    }

    if (orderId) {
      getRegistrationPaymentStatus(`?registrationId=${orderId}`).then((res) => {
        if (!res) {
          setCantBePaidModalVisible(true);
          return;
        }

        if (res.canBePaid) {
          dispatch({
            type: 'SET_REGISTRATION_ID',
            registrationId: orderId,
            redirectedToPaysera: true,
          });

          window.location.replace(res.paymentUrl);
        } else {
          if (res.alreadyPaid) {
            setCantBePaidModalText('Registracija jau apmokėta');
          } else if (res.alreadyCancelled) {
            setCantBePaidModalText('Registracija jau buvo atšaukta');
          } else if (res.outOfTime) {
            setCantBePaidModalText('Registracijos laikas jau praėjo');
          }
          setCantBePaidModalVisible(true);
        }
      });
    }
  }, []);

  if (error) {
    return <HeroError />;
  }

  function clearCart() {
    dispatch({
      type: 'REMOVE_LEFTTOPAYSERA',
    });
  }

  function getGroupedServices() {
    return groupBy(
      data.sort((a, b) => a.categoryId - b.categoryId),
      'categoryTitle',
    );
  }

  const categories = getGroupedServices();

  function scrollToServices() {
    const { top } = servicesRef.current?.getBoundingClientRect() || 0;

    window.scrollBy({
      top,
      left: 0,
      behavior: 'smooth',
    });
  }

  return (
    <>
      <div className="font-primary">
        <Hero onScroll={scrollToServices} />
        {/* <Container>
        <Benefits onScroll={scrollToServices} />
      </Container> */}

        {/* <Categories list={categories} loading={loading} ref={servicesRef} /> */}
        <CategoriesNew list={categories} loading={loading} ref={servicesRef} />
        <BenefitsSection />
      </div>
      <Modal
        visible={previewRegistrationCancelationModalVisible}
        onClose={() => {
          setPreviewRegistrationCancelationModalVisible(false);
        }}
        isGrey={true}
      >
        <Modal.TextContent isGrey={true}>
          {`Ar tikrai norite atšaukti registraciją ${registrationDate} "${serviceTitle}"?`}
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            onClick={async () => {
              setPreviewRegistrationCancelationModalVisible(false);
              cancelRegistration(registrationCancelationToken);
              if (manuallyConfirmedRegistrationVisible) {
                setCancelledRegistration(true);
              }
            }}
          >
            Taip
          </Button>
          <Button
            size="large"
            onClick={() => {
              setPreviewRegistrationCancelationModalVisible(false);
            }}
          >
            Ne
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        visible={previewRegistrationCancelationFailureModalVisible}
        onClose={() => {
          setPreviewRegistrationCancelationFailureModalVisible(false);
        }}
        isGrey={true}
      >
        <Modal.TextContent isGrey={true}>
          Užsakymas jau apmokėtas, todėl jo negalime atšaukti. Dėl pagalbos
          prašome kreiptis telefonu {phoneNumber}.
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            onClick={() => {
              setPreviewRegistrationCancelationFailureModalVisible(false);
            }}
          >
            Gerai
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        visible={manuallyConfirmedRegistrationVisible}
        onClose={() => {
          setManuallyConfirmedRegistrationVisible(false);
        }}
        isGrey={true}
      >
        <Modal.TextContent isGrey={true}>
          Atšaukimas negalimas. Registracija patvirtinta padalinyje.
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            onClick={() => {
              setManuallyConfirmedRegistrationVisible(false);
            }}
          >
            Gerai
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        visible={cancelledRegistration || registrationCancelled}
        onClose={() => {
          setCancelledRegistration(false);
          setRegistrationCancelled(false);
        }}
        disableBackdropClick={true}
        showClose={false}
        isGrey={true}
      >
        <Modal.TextContent isGrey={true}>
          {`Jūsų registracija buvo atšaukta, bet galite registruotis iš naujo.`}
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            loading={cancelLoading}
            disabled={cancelLoading}
            onClick={() => {
              setCancelledRegistration(false);
              setRegistrationCancelled(false);
            }}
          >
            Gerai
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        visible={cantBePaidModalVisible}
        onClose={() => {
          setCantBePaidModalVisible(false);
          history.push('/');
        }}
        isGrey={true}
      >
        <Modal.Alert type="error" isGrey={true}>
          Registracijos apmokėjimas
        </Modal.Alert>
        <Modal.TextContent isGrey={true}>
          <div>
            {cantBePaidModalText}
            <p>
              Pabandykite pakartoti iš naujo arba skambinkite telefonu{' '}
              {phoneNumber}
            </p>
          </div>
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            onClick={() => {
              setCantBePaidModalVisible(false);
              history.push('/');
            }}
          >
            Gerai
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        visible={showLinkExpiryModal}
        loading={false}
        onClose={() => setShowLinkExpiryModal(false)}
        isGrey={true}
      >
        <Modal.TextContent isGrey={true}>
          Paskyros kūrimo nuoroda nebegalioja! Kreipkitės į Affidea padalinį,
          kad inicijuotų jums paskyros kūrimą iš naujo.
        </Modal.TextContent>
        <Modal.Actions>
          <Button size="large" onClick={() => setShowLinkExpiryModal(false)}>
            Ok
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        visible={isCancelModalVisible}
        showClose={false}
        onClose={handleKeepRegistration}
      >
        <Modal.TextContent>
          Ar tikrai norite atšaukti registraciją?
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            disabled={cancelLoading}
            onClick={handleKeepRegistration}
          >
            Ne
          </Button>
          <Button
            size="large"
            loading={cancelLoading}
            disabled={cancelLoading}
            onClick={handleConfirmCancellation}
          >
            Taip
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default CategoriesPage;
